
import fetch from './fetch'

const fetchCollection = (catalogURL, opts = {}) => {
  return fetch(catalogURL, { ...opts, collection: true })
}

export default fetchCollection
